export default Object.freeze({
  background: [ 255, 255, 255 ],
  digits: 2,
  fillColour: [ 34, 34, 34 ],
  fontSize: 13,
  height: 24,
  lineWidth: 1,
  opacity: 0.87,
  padding: 4,
  position: {
    bottom: 0,
    left: 0,
  },
  strokeColour: [ 34, 34, 34 ],
  textAlign: "center",
  textBaseline: "hanging",
  width: 96,
});
